import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setIncludeVersionComment: YJSChangeHandler<
  DatabaseChangeType.SET_INCLUDE_VERSION_COMMENT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.includeVersionComment = change.includeVersionComment;
  });
};
